import { useMemo } from "react";
import Svg from "e.sic-platform.webclient/src/components/svg/Svg";
import { Cameraswitch, ShoppingCart, Assignment} from "@mui/icons-material";
import useThemeService from 'e.sic-platform.webclient/src/services/theme-service/ThemeService';
import { useTheme } from "@mui/material";
import { Detection, RunAI, SmartManagerWhite, CombinedAnalysisSegmentation, CombinedAnalysisOcr } from "e.sic-platform.webclient/src/components/svg/svgImageList";
import { ActivityTypes } from "e.sic-platform.webclient/src/services/shop/ActivityPricesStorage";
import { featureFlagsStorage } from "e.sic-platform.webclient/src/services/feature-flags/FeatureFlagsStorage";
import { Flags } from "e.sic-platform.webclient/src/generated/FeatureFlags";

export interface MainMenuItemCategory {
  service: ActivityTypes[] | undefined;
  name: string;
  canAccess: boolean;
  path?: string;
  aliases?: string[];
  icon: any;
  iconSelected: any;
  hide?: boolean;
  withDivider?: boolean;
}

export default function useMenuStorage() {
  const { themeClass } = useThemeService();
  const {palette} = useTheme();
  
  const menuCategories: MainMenuItemCategory[] = useMemo(
    () => {
      const ocrItem = {
        service: [ActivityTypes.VideoOcr],
        name: "inspection-insights",
        path: "/inspection-insights",
        icon: (<Svg svg={Assignment} style={{ padding: "15px", color: "white" }} />),
        iconSelected: (<Svg svg={Assignment} style={{ padding: "15px", color: palette.primary.light }}/>),
        canAccess: true,
      }
      const ocrAndAnalysisItem = {
          service: [ActivityTypes.VideoAnalysis, ActivityTypes.VideoOcr],
          name: "analysis-and-inspection-insights",
          path: "/analysis-and-inspection-insights",
          icon: (<Svg svg={CombinedAnalysisOcr} className={themeClass(["icon-custom"])}/>),
          iconSelected: (<Svg svg={CombinedAnalysisOcr} className={themeClass(["icon-custom-main"])}/>),
          canAccess: true,
      }
      const items = 
      [
        {
          service: undefined,
          withDivider: true, 
          name: "smart-manager", 
          path: JSON.parse(sessionStorage["config-storage"]).platform_url, 
          icon: (<Svg svg={SmartManagerWhite} className={themeClass(["icon-custom-logo"])}/>),
          iconSelected: (<Svg svg={SmartManagerWhite} className={themeClass(["icon-custom-logo"])}/>),
          canAccess: true
        },
        {
          service: undefined,
          name: "shop-history",
          path: "app-usage",
          canAccess: true,
          icon: (<></>),
          iconSelected: (<></>),
          hide: true
        },
        {
          service: undefined,
          name: "shop",
          path: "/shop",
            icon: (<Svg svg={ShoppingCart} style={{padding: "15px", color: "white"}}/>),
            iconSelected: (<Svg svg={ShoppingCart} style={{padding: "15px", color: palette.primary.light}}/>),
            canAccess: true
        },
        {
          service: [ActivityTypes.VideoConversion],
          name: "video-conversion",
          path: "/video-conversion",
          icon: (<Svg svg={Cameraswitch} style={{padding: "15px", color: "white"}}/>),
          iconSelected: (<Svg svg={Cameraswitch} style={{padding: "15px", color: palette.primary.light}}/>),
          canAccess: true
        },
        {
          service: [ActivityTypes.HighlightDetection],
          name: "video-segmentation",
          path: "/video-segmentation",
          icon: (<Svg svg={Detection} className={themeClass(["icon-custom"])}/>),
          iconSelected: (<Svg svg={Detection} className={themeClass(["icon-custom-main"])}/>),
          canAccess: true
        },
        {
          service: [ActivityTypes.VideoAnalysis],
          name: "video-analysis",
          path: "/video-analysis",
            icon: (<Svg svg={RunAI} className={themeClass(["icon-custom"])}/>),
            iconSelected: (<Svg svg={RunAI} className={themeClass(["icon-custom-main"])}/>),
            canAccess: true
        },
        {
          service: [ActivityTypes.VideoAnalysis, ActivityTypes.HighlightDetection],
          name: "analysis-and-segmentation",
          path: "/analysis-and-segmentation",
          icon: (<Svg svg={CombinedAnalysisSegmentation} className={themeClass(["icon-custom"])}/>),
          iconSelected: (<Svg svg={CombinedAnalysisSegmentation} className={themeClass(["icon-custom-main"])}/>),
          canAccess: true,
        },
      ]
      if (featureFlagsStorage.isFeatureEnabled(Flags.Enable_Ocr)) items.push(ocrItem)
      if (featureFlagsStorage.isFeatureEnabled(Flags.Enable_Ocr_Analysis)) items.push(ocrAndAnalysisItem)
      return items.reverse();
  }, []);

  return { menuCategories };
}
